import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { extractApiError } from "../api/apiErrorHandler";
import { showToast } from "components/toast";
import { fetchOrder } from "api/orderApi";
import { createOrder } from "api/orderApi";
import { fetchOrderStatus } from "api/orderApi";
import { fetchUsers } from "api/usersApi";
import { fetchOrderDetails } from "api/orderApi";
import { deleteOrderItemApi } from "api/orderApi";
import { changeOrderStatusApi } from "api/orderApi";
import { splitOrderItemApi } from "api/orderApi";
import { reverseSplitOrderItemApi } from "api/orderApi";
import { updateOrderItemApi } from "api/orderApi";
import { deleteOrderApi } from "api/orderApi";

const initialState = {
  placedData: {},
  placedLoading: false,
  placedError: null,

  orderDetailsData: {},
  orderDetailsLoading: false,
  orderDetailsError: null,

  orderEditDetailsData: {},
  orderEditDetailsLoading: false,
  orderEditDetailsError: null,

  userListData: {},
  userListLoading: false,
  userListError: null,

  createLoading: false,
  createError: null,

  createItemsLoading: false,
  createItemsError: null,

  orderStatusData: [],
  orderStatusLoading: false,
  orderStatusError: null,

  // Delete Items
  deleteOrderLoading: false,
  deleteOrderError: null,

  // Delete Items
  deleteOrderItemLoading: false,
  deleteOrderItemError: null,

  // Edit
  orderChangeStatusLoading: false,
  orderChangeStatusError: null,

  // Edit item
  updateOrderItemLoading: false,
  updateOrderItemError: null,

  splitOrderItemLoading: false,
  splitOrderItemError: null,

  reverseSplitOrderItemLoading: false,
  reverseSplitOrderItemError: null,
};

// 🔹 Get Placed Order
export const getPlacedOrder = createAsyncThunk(
  "orders/getPlacedOrder",
  async (data, thunkAPI) => {
    try {
      return await fetchOrder(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(extractApiError(error));
    }
  }
);
// 🔹 Get Order
export const getOrderDetails = createAsyncThunk(
  "orders/getOrderDetails",
  async (data, thunkAPI) => {
    try {
      return await fetchOrderDetails(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(extractApiError(error));
    }
  }
);
// 🔹 Get Order
export const getEditOrderDetails = createAsyncThunk(
  "orders/getEditOrderDetails",
  async (data, thunkAPI) => {
    try {
      return await fetchOrderDetails(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(extractApiError(error));
    }
  }
);
// 🔹 Get user
export const getUsersList = createAsyncThunk(
  "orders/getUsersList",
  async (data, thunkAPI) => {
    try {
      return await fetchUsers(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(extractApiError(error));
    }
  }
);
// 🔹 Create Order
export const AddNewOrder = createAsyncThunk(
  "orders/AddNewOrder",
  async (data, thunkAPI) => {
    try {
      return await createOrder(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(extractApiError(error));
    }
  }
);
// 🔹 Create Order
export const AddNewOrderItems = createAsyncThunk(
  "orders/AddNewOrderItems",
  async (data, thunkAPI) => {
    try {
      return await createOrder(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(extractApiError(error));
    }
  }
);

// 🔹 Get Order Status
export const getOrderStatus = createAsyncThunk(
  "orders/getOrderStatus",
  async (data, thunkAPI) => {
    try {
      return await fetchOrderStatus(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(extractApiError(error));
    }
  }
);
// 🔹 Delete Order
export const deleteOrder = createAsyncThunk(
  "orders/deleteOrder",
  async (data, thunkAPI) => {
    try {
      return await deleteOrderApi(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(extractApiError(error));
    }
  }
);
// 🔹 Delete Items
export const deleteOrderItem = createAsyncThunk(
  "orders/deleteOrderItem",
  async (data, thunkAPI) => {
    try {
      return await deleteOrderItemApi(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(extractApiError(error));
    }
  }
);

// 🔹 Change Status
export const changeOrderStatus = createAsyncThunk(
  "orders/changeOrderStatus",
  async (userData, thunkAPI) => {
    try {
      const response = await changeOrderStatusApi(userData);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(extractApiError(error));
    }
  }
);
// 🔹 update item
export const updateOrderItem = createAsyncThunk(
  "orders/updateOrderItem",
  async (data, thunkAPI) => {
    try {
      const response = await updateOrderItemApi(data);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(extractApiError(error));
    }
  }
);

// 🔹 split items
export const splitOrderItem = createAsyncThunk(
  "orders/splitOrderItem",
  async (data, thunkAPI) => {
    try {
      return await splitOrderItemApi(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(extractApiError(error));
    }
  }
);
// 🔹 reverse split items
export const reverseSplitOrderItem = createAsyncThunk(
  "orders/reverseSplitOrderItem",
  async (data, thunkAPI) => {
    try {
      return await reverseSplitOrderItemApi(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(extractApiError(error));
    }
  }
);

const orderSlice = createSlice({
  name: "orders",
  initialState,
  reducers: {
    resetPlacedOrderData: (state) => {
      state.placedData = {};
      state.placedLoading = false;
      state.placedError = null;
    },
    resetOrderDetails: (state) => {
      state.orderDetailsData = {};
      state.orderDetailsLoading = false;
      state.orderDetailsError = null;
    },
    resetEditOrderDetails: (state) => {
      state.orderEditDetailsData = {};
      state.orderEditDetailsLoading = false;
      state.orderEditDetailsError = null;
    },
    resetOrderStatusError: (state) => {
      state.orderChangeStatusLoading = false;
      state.orderChangeStatusError = null;
    },
  },
  extraReducers: (builder) => {
    // ➕ GET PLACED ORDER
    builder
      .addCase(getPlacedOrder.pending, (state) => {
        state.placedLoading = true;
        state.placedError = null;
      })
      .addCase(getPlacedOrder.fulfilled, (state, action) => {
        state.placedLoading = false;
        state.placedError = null;
        state.placedData = action.payload;
      })
      .addCase(getPlacedOrder.rejected, (state, action) => {
        state.placedLoading = false;
        state.placedError = action.payload;
      });
    // ➕ GET ORDER DETAILS
    builder
      .addCase(getOrderDetails.pending, (state) => {
        state.orderDetailsLoading = true;
        state.orderDetailsError = null;
      })
      .addCase(getOrderDetails.fulfilled, (state, action) => {
        state.orderDetailsLoading = false;
        state.orderDetailsError = null;
        state.orderDetailsData = action.payload.data;
      })
      .addCase(getOrderDetails.rejected, (state, action) => {
        state.orderDetailsLoading = false;
        state.orderDetailsError = action.payload;
      });
    // ➕ GET EDIT ORDER DETAILS
    builder
      .addCase(getEditOrderDetails.pending, (state) => {
        state.orderEditDetailsLoading = true;
        state.orderEditDetailsError = null;
      })
      .addCase(getEditOrderDetails.fulfilled, (state, action) => {
        state.orderEditDetailsLoading = false;
        state.orderEditDetailsError = null;
        state.orderEditDetailsData = action.payload.data;
      })
      .addCase(getEditOrderDetails.rejected, (state, action) => {
        state.orderEditDetailsLoading = false;
        state.orderEditDetailsError = action.payload;
      });
    builder
      .addCase(getUsersList.pending, (state) => {
        state.userListLoading = true;
        state.userListError = null;
      })
      .addCase(getUsersList.fulfilled, (state, action) => {
        state.userListLoading = false;
        state.userListError = null;
        state.userListData = action.payload.data.users;
      })
      .addCase(getUsersList.rejected, (state, action) => {
        state.userListLoading = false;
        state.userListError = action.payload;
      });
    // ➕ CREATE ORDER
    builder
      .addCase(AddNewOrder.pending, (state) => {
        state.createLoading = true;
        state.createError = null;
      })
      .addCase(AddNewOrder.fulfilled, (state) => {
        state.createLoading = false;
        showToast.success("Order created successfully!");
      })
      .addCase(AddNewOrder.rejected, (state, action) => {
        state.createLoading = false;
        state.createError = action.payload || "Failed to create order";
        showToast.error(state.createError);
      });
    // ➕ CREATE ORDER ITEMS
    builder
      .addCase(AddNewOrderItems.pending, (state) => {
        state.createItemsLoading = true;
        state.createItemsError = null;
      })
      .addCase(AddNewOrderItems.fulfilled, (state) => {
        state.createItemsLoading = false;
        showToast.success("Order items added successfully!");
      })
      .addCase(AddNewOrderItems.rejected, (state, action) => {
        state.createItemsLoading = false;
        state.createItemsError =
          action.payload || "Failed to create order items";
        showToast.error(state.createItemsError);
      });
    // ➕  ORDER STATUS LIST
    builder
      .addCase(getOrderStatus.pending, (state) => {
        state.orderStatusLoading = true;
        state.orderStatusError = null;
      })
      .addCase(getOrderStatus.fulfilled, (state, action) => {
        state.orderStatusLoading = false;
        state.orderStatusError = null;
        state.orderStatusData = action.payload.data;
      })
      .addCase(getOrderStatus.rejected, (state, action) => {
        state.orderStatusLoading = false;
        state.orderStatusError = action.payload;
      });
    // 🗑️ DELETE ORDER
    builder
      .addCase(deleteOrder.pending, (state) => {
        state.deleteOrderLoading = true;
        state.deleteOrderError = null;
      })
      .addCase(deleteOrder.fulfilled, (state) => {
        state.deleteOrderLoading = false;
        showToast.success("Order deleted successfully.");
      })
      .addCase(deleteOrder.rejected, (state, action) => {
        state.deleteOrderLoading = false;
        state.deleteOrderError = action.payload || "Failed to delete order";
        showToast.error(state.deleteOrderError);
      });
    // 🗑️ DELETE ORDER ITEM
    builder
      .addCase(deleteOrderItem.pending, (state) => {
        state.deleteOrderItemLoading = true;
        state.deleteOrderItemError = null;
      })
      .addCase(deleteOrderItem.fulfilled, (state) => {
        state.deleteOrderItemLoading = false;
        showToast.success("Item deleted successfully.");
      })
      .addCase(deleteOrderItem.rejected, (state, action) => {
        state.deleteOrderItemLoading = false;
        state.deleteOrderItemError = action.payload || "Failed to delete item";
        showToast.error(state.deleteOrderItemError);
      });
    // ✏️ CHANGE ORDER STATUS
    builder
      .addCase(changeOrderStatus.pending, (state) => {
        state.orderChangeStatusLoading = true;
        state.orderChangeStatusError = null;
      })
      .addCase(changeOrderStatus.fulfilled, (state) => {
        state.orderChangeStatusLoading = false;
        // showToast.success("Order placed successfully!");
      })
      .addCase(changeOrderStatus.rejected, (state, action) => {
        state.orderChangeStatusLoading = false;
        state.orderChangeStatusError =
          action.payload || "Failed to Order placed";
        // showToast.error(state.orderChangeStatusError);
      });
    // ✏️ UPDATE ORDER ITEM
    builder
      .addCase(updateOrderItem.pending, (state) => {
        state.updateOrderItemLoading = true;
        state.updateOrderItemError = null;
      })
      .addCase(updateOrderItem.fulfilled, (state) => {
        state.updateOrderItemLoading = false;
        showToast.success("item updated successfully!");
      })
      .addCase(updateOrderItem.rejected, (state, action) => {
        state.updateOrderItemLoading = false;
        state.updateOrderItemError = action.payload || "Failed to item Update";
        showToast.error(state.updateOrderItemError);
      });
    //  SPLIT ITEMS
    builder
      .addCase(splitOrderItem.pending, (state) => {
        state.splitOrderItemLoading = true;
        state.splitOrderItemError = null;
      })
      .addCase(splitOrderItem.fulfilled, (state) => {
        state.splitOrderItemLoading = false;
        showToast.success("Order item split successfully!");
      })
      .addCase(splitOrderItem.rejected, (state, action) => {
        state.splitOrderItemLoading = false;
        state.splitOrderItemError = action.payload || "Failed to split item";
        showToast.error(state.splitOrderItemError);
      });
    // REVERSE SPLIT ITEM
    builder
      .addCase(reverseSplitOrderItem.pending, (state) => {
        state.reverseSplitOrderItemLoading = true;
        state.reverseSplitOrderItemError = null;
      })
      .addCase(reverseSplitOrderItem.fulfilled, (state) => {
        state.reverseSplitOrderItemLoading = false;
        showToast.success("Order item reversed successfully!");
      })
      .addCase(reverseSplitOrderItem.rejected, (state, action) => {
        state.reverseSplitOrderItemLoading = false;
        state.reverseSplitOrderItemError =
          action.payload || "Failed to reversed item";
        showToast.error(state.reverseSplitOrderItemError);
      });
  },
});
export const {
  resetOrderDetails,
  resetEditOrderDetails,
  resetPlacedOrderData,
  resetOrderStatusError,
} = orderSlice.actions;
export default orderSlice.reducer;
